import { Api_Host } from "../api";

export const getAllObjectImpuesto_Api = () => Api_Host.get('/objetoimpuesto/');
